import { render } from "./PayCardBack.vue?vue&type=template&id=bf404e48&ts=true"
import script from "./PayCardBack.vue?vue&type=script&lang=ts"
export * from "./PayCardBack.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__